/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const timesheetCustomerDtoSchema = z.object({
  customerId: z.coerce.number().int(),
  customerName: z.coerce.string(),
});
